<script setup lang="ts">
import { computed } from 'vue';

import successSmallIcon from '@/assets/icons/success-small.svg';
import { type StatusDisplayedDetailsItem } from '@/composables/useTransactionDetails';

import UiBlinker from '@/components/ui/UiBlinker.vue';
import UiIcon from '@/components/ui/UiIcon.vue';
import UiText from '@/components/ui/UiText.vue';

interface Props {
  item: StatusDisplayedDetailsItem;
}

const props = defineProps<Props>();

const valueParts = computed((): string[] => props.item.value.split(', '));

const mutedValue = computed((): string => (valueParts.value.length > 1 ? valueParts.value[0] : ''));

const value = computed((): string => {
  if (valueParts.value.length > 1) {
    const [, ...other] = valueParts.value;
    return `, ${other.join(',')}`;
  }

  return props.item.value;
});
</script>

<template>
  <span class="transaction-status-details-item">
    <span class="transaction-status-details-item__label">
      <UiIcon
        class="transaction-status-details-item__label-icon"
        :size="16"
        :name="successSmallIcon"
      />
      <UiText size="sm" weight="medium">{{ props.item.name }}</UiText>
    </span>
    <UiText class="transaction-status-details-item__value" size="sm" weight="medium" align="right">
      <UiBlinker :blinking="props.item.skeleton">
        <UiText v-if="mutedValue" muted>{{ mutedValue }}</UiText
        >{{ value }}
      </UiBlinker>
    </UiText>
  </span>
</template>

<style scoped>
.transaction-status-details-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.transaction-status-details-item__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 50%;
  padding: 0 8px 0 0;
  color: var(--color-green);
}

.transaction-status-details-item__label-icon {
  flex-shrink: 0;
  margin: 0 8px 0 0;
}

.transaction-status-details-item__value {
  display: flex;
  align-items: center;
}

.transaction-status-details-item__value-text {
  white-space: pre-wrap;
  vertical-align: middle;
}
</style>
